// Generated by Melange

import * as Buhta_conf__Config from "../../../../packages/conf/lib/Config.js";
import * as Buhta_models__Cms from "../../../../packages/models/Cms.js";
import * as Caml_exceptions from "melange.js/caml_exceptions.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Fetch from "melange-fetch/Fetch.js";
import * as $$Promise from "../../../../vendored/promise/promise.js";
import * as Stdlib__List from "melange/list.js";

const Api_error = /* @__PURE__ */ Caml_exceptions.create("Buhta_landing.Api.Api_error");

function request(url) {
  const cmsUrl = Buhta_conf__Config.getConfig(undefined).cms_api_url;
  const __x = $$Promise.Js.toResult($$Promise.Js.fromBsPromise(fetch(cmsUrl + url, Fetch.RequestInit.make(/* Get */ 0, {
    "content-type": "application/json",
    accept: "application/json"
  }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined))));
  return $$Promise.flatMapOk(__x, (function (data) {
    return $$Promise.Js.toResult($$Promise.Js.fromBsPromise(data.json()));
  }));
}

function blogTags(language) {
  const __x = request("/wiki-tags?language=" + language);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* BlogTags */ 0,
      _0: Buhta_models__Cms.BlogTags.decode(data)
    };
  }));
}

function blogPosts(page, tag, language) {
  const page$1 = String(page);
  const url = "/wiki-pages-results?_offsetPage=" + page$1 + "&tag=" + tag + "&language=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* BlogPosts */ 1,
      _0: Buhta_models__Cms.BlogPosts.decode(data)
    };
  }));
}

function blogFavorites(language) {
  const url = "/wiki-pages-results/favorites?language=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* BlogFavorites */ 2,
      _0: Buhta_models__Cms.BlogFavorites.decode(data)
    };
  }));
}

function blogSearch(query, language) {
  const url = "/wiki-pages/search?query=" + query + "&language=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    let tmp;
    try {
      tmp = Buhta_models__Cms.BlogSearch.decode(data);
    }
    catch (raw_err){
      const err = Caml_js_exceptions.internalToOCamlException(raw_err);
      console.log("blog search decode error", err);
      tmp = /* [] */ 0;
    }
    return {
      TAG: /* BlogSearch */ 3,
      _0: tmp
    };
  }));
}

function wikiPage(pageId) {
  const url = "/wiki-pages/" + pageId;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* WikiPage */ 4,
      _0: Buhta_models__Cms.WikiPage.decode(data)
    };
  }));
}

function libraryTags(language) {
  const url = "/wiki-tags-library?language=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* LibraryTags */ 5,
      _0: Buhta_models__Cms.LibraryTags.decode(data)
    };
  }));
}

function libraryArticles(page, tag, language) {
  const page$1 = String(page);
  const url = "/wiki-pages-results/library?_offsetPage=" + page$1 + "&tag=" + tag + "&language=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* LibraryArticles */ 6,
      _0: Buhta_models__Cms.LibraryArticles.decode(data)
    };
  }));
}

function libraryFavorites(language) {
  const url = "/wiki-pages-results/library-favorites?language=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* LibraryFavorites */ 7,
      _0: Buhta_models__Cms.LibraryFavorites.decode(data)
    };
  }));
}

function librarySearch(query, language) {
  const url = "/wiki-pages/search-library?query=" + query + "&language=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* LibrarySearch */ 8,
      _0: Buhta_models__Cms.LibrarySearch.decode(data)
    };
  }));
}

function aboutPage(language) {
  const url = "/about-page?_locale=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* AboutPage */ 9,
      _0: Buhta_models__Cms.AboutPage.decode(data)
    };
  }));
}

function outsourcing(country) {
  const url = "/outsourcings?_country=" + country;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* Outsourcing */ 10,
      _0: Buhta_models__Cms.Outsourcing.decode(data)
    };
  }));
}

function requisites(language) {
  const url = "/requisites?_locale=" + language + "&_sort=id:ASC";
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* Requisites */ 11,
      _0: Buhta_models__Cms.Requisites.decode(data)
    };
  }));
}

function faq(param) {
  const __x = request("/faqs");
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* FAQ */ 12,
      _0: Buhta_models__Cms.FAQ.decode(data)
    };
  }));
}

function homePage(language) {
  const url = "/home-page?_locale=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* HomePage */ 13,
      _0: Buhta_models__Cms.HomePage.decode(data)
    };
  }));
}

function jobCategories(param) {
  const __x = request("/job-categories");
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* JobCategories */ 14,
      _0: Buhta_models__Cms.JobCategories.decode(data)
    };
  }));
}

function mainMenu(language, country) {
  const url = "/main-menus?_locale=" + language + "&_country=" + country;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* MainMenu */ 15,
      _0: Buhta_models__Cms.MainMenu.decode(data)
    };
  }));
}

function pricingPage(language) {
  const url = "/pricing-page?_locale=" + language;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* PricingPage */ 16,
      _0: Buhta_models__Cms.PricingPage.decode(data)
    };
  }));
}

function pricingCategories(country) {
  const url = "/pricing-categories?_country=" + country;
  const __x = request(url);
  return $$Promise.mapOk(__x, (function (data) {
    return {
      TAG: /* PricingCategories */ 17,
      _0: Buhta_models__Cms.PricingCategories.decode(data)
    };
  }));
}

function submitRequest(data) {
  const cmsUrl = Buhta_conf__Config.getConfig(undefined).cms_api_url;
  const __x = $$Promise.Js.toResult($$Promise.Js.fromBsPromise(fetch(cmsUrl + "/requests", Fetch.RequestInit.make(/* Post */ 2, {
    "content-type": "application/json",
    accept: "application/json"
  }, Caml_option.some(JSON.stringify(data)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined))));
  return $$Promise.flatMapOk(__x, (function (data) {
    return $$Promise.Js.toResult($$Promise.Js.fromBsPromise(data.json()));
  }));
}

function handleResponse(res, dispatch, param) {
  if (res.TAG !== /* Ok */ 0) {
    return;
  }
  const posts = res._0;
  switch (posts.TAG) {
    case /* BlogTags */ 0 :
      return Curry._1(dispatch, {
        TAG: /* BlogTags */ 0,
        _0: posts._0
      });
    case /* BlogPosts */ 1 :
      return Curry._1(dispatch, {
        TAG: /* BlogPosts */ 1,
        _0: posts._0
      });
    case /* BlogFavorites */ 2 :
      return Curry._1(dispatch, {
        TAG: /* BlogFavorites */ 2,
        _0: posts._0
      });
    case /* BlogSearch */ 3 :
      return Curry._1(dispatch, {
        TAG: /* BlogSearch */ 3,
        _0: posts._0
      });
    case /* WikiPage */ 4 :
      return Curry._1(dispatch, {
        TAG: /* WikiPage */ 4,
        _0: posts._0
      });
    case /* LibraryTags */ 5 :
      return Curry._1(dispatch, {
        TAG: /* LibraryTags */ 5,
        _0: posts._0
      });
    case /* LibraryArticles */ 6 :
      return Curry._1(dispatch, {
        TAG: /* LibraryArticles */ 6,
        _0: posts._0
      });
    case /* LibraryFavorites */ 7 :
      return Curry._1(dispatch, {
        TAG: /* LibraryFavorites */ 7,
        _0: posts._0
      });
    case /* LibrarySearch */ 8 :
      return Curry._1(dispatch, {
        TAG: /* LibrarySearch */ 8,
        _0: posts._0
      });
    case /* AboutPage */ 9 :
      return Curry._1(dispatch, {
        TAG: /* AboutPage */ 9,
        _0: posts._0
      });
    case /* Outsourcing */ 10 :
      return Curry._1(dispatch, {
        TAG: /* Outsourcing */ 10,
        _0: posts._0
      });
    case /* Requisites */ 11 :
      return Curry._1(dispatch, {
        TAG: /* Requisites */ 11,
        _0: posts._0
      });
    case /* FAQ */ 12 :
      return Curry._1(dispatch, {
        TAG: /* FAQ */ 12,
        _0: posts._0
      });
    case /* HomePage */ 13 :
      return Curry._1(dispatch, {
        TAG: /* HomePage */ 13,
        _0: posts._0
      });
    case /* JobCategories */ 14 :
      return Curry._1(dispatch, {
        TAG: /* JobCategories */ 14,
        _0: posts._0
      });
    case /* MainMenu */ 15 :
      const sortedData = Stdlib__List.sort((function (a, b) {
        return a.order - b.order | 0;
      }), posts._0);
      return Curry._1(dispatch, {
        TAG: /* MainMenu */ 15,
        _0: sortedData
      });
    case /* PricingPage */ 16 :
      return Curry._1(dispatch, {
        TAG: /* PricingPage */ 16,
        _0: posts._0
      });
    case /* PricingCategories */ 17 :
      return Curry._1(dispatch, {
        TAG: /* PricingCategories */ 17,
        _0: posts._0
      });
  }
}

export {
  Api_error,
  request,
  blogTags,
  blogPosts,
  blogFavorites,
  blogSearch,
  wikiPage,
  libraryTags,
  libraryArticles,
  libraryFavorites,
  librarySearch,
  aboutPage,
  outsourcing,
  requisites,
  faq,
  homePage,
  jobCategories,
  mainMenu,
  pricingPage,
  pricingCategories,
  submitRequest,
  handleResponse,
}
/* Buhta_conf__Config Not a pure module */
